import { useMemo } from 'react';
import { defineMessage, useIntl } from 'react-intl';

var selectedItemsLabel = defineMessage({ id: "EKDPMN", defaultMessage: [{ type: 1, value: "selected" }, { type: 0, value: " of " }, { type: 1, value: "total" }, { type: 0, value: " selected" }] });
var selectAllLabel = defineMessage({ id: "Ym8W1b", defaultMessage: [{ type: 0, value: "Select All (" }, { type: 1, value: "total" }, { type: 0, value: " results)" }] });
var useSelectAll = function (_a) {
    var items = _a.items, selectedItems = _a.selectedItems;
    var intl = useIntl();
    var showSelectAll = items.length > 1;
    var allSelected = useMemo(function () {
        return items.every(function (item) { return selectedItems.includes(item); });
    }, [items, selectedItems, showSelectAll]);
    var selectAllItem = useMemo(function () {
        if (!showSelectAll)
            return {};
        return {
            value: intl.formatMessage(selectedItems.length ? selectedItemsLabel : selectAllLabel, {
                selected: selectedItems.length,
                total: items.length
            }),
            checked: allSelected,
            indeterminate: !allSelected && selectedItems.length > 0
        };
    }, [showSelectAll, selectedItems, items]);
    return { allSelected: allSelected, selectAllItem: selectAllItem, showSelectAll: showSelectAll };
};

export { useSelectAll };
//# sourceMappingURL=useSelectAll.esm.js.map
